__turbopack_context__.v({
  "decoration": "S8HcIW_decoration",
  "light": "S8HcIW_light",
  "lights": "S8HcIW_lights",
  "root": "S8HcIW_root",
  "upgradedLight": "S8HcIW_upgradedLight",
  "wrapper": "S8HcIW_wrapper",
});
